<div class="table-responsive small">

  <!-- Loading -->
  <ng-container *ngIf="isSurveyHistoryLoading">
    <div class="loading-cover">
      <fa-icon class="me-2" [icon]="faCircleNotch" [spin]="true"></fa-icon> Loading
    </div>
  </ng-container>

  <!-- No Results -->
  <ng-container *ngIf="!isSurveyHistoryLoading && surveys.length === 0">
    <p class="rem1 mt-3">There are no survey history records to show.</p>
  </ng-container>

  <!-- Results -->
  <ng-container *ngIf="!isSurveyHistoryLoading && surveys.length > 0">
    <table class="table table-sm table-striped">
      <thead>
        <tr>
          <th scope="col">Date</th>
          <th scope="col">Method</th>
          <th scope="col">Versions</th>
          <th scope="col">Approval Needed</th>
          <th scope="col"></th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let m of surveys">
          <td>{{ m.surveyDate! | formatUtcDate }}</td>
          <td>{{ m.surveyMethod!.value }}</td>
          <td>{{ m.versions!.length }}</td>
          <td>
            {{ doesSurveyNeedApproval(m) === false ? 'No' : '' }}
            <ng-container *ngIf="doesSurveyNeedApproval(m) === true">
              <a class="badge rounded-pill text-bg-primary"
                [routerLink]="['/surveys/details', m.surveyId, month, year]">Yes</a>
            </ng-container>
          </td>
          <td><a class="btn btn-link btn-sm p-0 m-0"
              [routerLink]="['/surveys/details', m.surveyId, matterNumber, month, year]">
              Details
            </a>
          </td>
          <td><a class="btn btn-link btn-sm p-0 m-0" 
                  [hidden]="!this.accountInfo?.isAdmin" 
                  (click)="deleteSurvey(m)">Delete</a>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>

</div>